/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_ViewInputs */

const en_mk_shot_view = /** @type {(inputs: Mk_Shot_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlarge`)
};

const id_mk_shot_view = /** @type {(inputs: Mk_Shot_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbesar`)
};

/**
* | output |
* | --- |
* | "Enlarge" |
*
* @param {Mk_Shot_ViewInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_view = /** @type {((inputs?: Mk_Shot_ViewInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_ViewInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_view(inputs)
	return en_mk_shot_view(inputs)
});